module.exports = __webpack_public_path__ + "img/wrong.796527b5.png";